// import SanityClient  from "@sanity/client/sanityClient";
import sanityClient from '@sanity/client';
// import { SanityDatabase } from '../config';

export default sanityClient({
  // Find your project ID and dataset in `sanity.json` in your studio project
  projectId: 'znl9re2x',
  dataset: process.env.REACT_APP_SANITY_DATABASE ?? 'production',
  useCdn: true,
  apiVersion: '2022-06-02',
  // token required to fetch translations
  token:
    'sk9CRgRgiPwapm7vrtuOGAH9cVLrtocdHhTO6mQDnP3ph93yLWFGwgcUEWLDRfGZd2Qon5e9dTO0KjQNIMoPP3LVQc6HXojKAaWU5CC3JoVr7mBzpaN4P2VF6MOkOmslruVEaYCAacmJb7WZA4HIv1dMis7w8fQBs6qw3DQc8PqtEiKm3VTl',
  // useCdn == true gives fast, cheap responses using a globally distributed cache.
  // Set this to false if your application require the freshest possible
  // data always (potentially slightly slower and a bit more expensive).
});
